import { memo } from "react";
import { Handle, Position } from "reactflow";
import { User, ArrowRight } from "@phosphor-icons/react";

function RoleNode({ data }) {
  const { title, department, purpose, kpis = [], photo_url, trainingMode, presentationMode, onSelect } = data;
  const handleStyle = "!bg-primary !w-3 !h-3 !border-2 !border-white";

  return (
    <div
      className={`node-card bg-white border-2 border-black/10 rounded-md shadow-sm min-w-[220px] max-w-[280px] cursor-pointer
        hover:border-primary/50 ${trainingMode ? 'training-highlight relative' : ''} ${presentationMode ? 'scale-110' : ''}`}
      onClick={onSelect}
      data-testid={`role-node-${data.role_id}`}
    >
      {/* 4-side handles so edges always connect to nearest side */}
      <Handle id="t" type="source"   position={Position.Top}    className={handleStyle} />
      <Handle id="t-in" type="target" position={Position.Top}   className={handleStyle} />
      <Handle id="b" type="source"   position={Position.Bottom} className={handleStyle} />
      <Handle id="b-in" type="target" position={Position.Bottom} className={handleStyle} />
      <Handle id="l" type="source"   position={Position.Left}   className={handleStyle} />
      <Handle id="l-in" type="target" position={Position.Left}  className={handleStyle} />
      <Handle id="r" type="source"   position={Position.Right}  className={handleStyle} />
      <Handle id="r-in" type="target" position={Position.Right} className={handleStyle} />

      {/* Header */}
      <div className="bg-primary/5 border-b border-black/5 px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full overflow-hidden bg-primary/10 flex items-center justify-center shrink-0">
            {photo_url ? (
              <img src={photo_url} alt={title} className="w-full h-full object-cover" />
            ) : (
              <User size={18} weight="bold" className="text-primary" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-sm text-foreground truncate">{title}</h3>
            <p className="text-xs text-muted-foreground truncate">{department}</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 py-3">
        {purpose && (
          <p className="text-xs text-muted-foreground line-clamp-2 mb-2">{purpose}</p>
        )}
        
        {/* KPIs Preview */}
        {kpis.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {kpis.slice(0, 2).map((kpi, idx) => (
              <span
                key={idx}
                className="inline-flex items-center px-2 py-0.5 rounded bg-accent/20 text-accent-foreground text-[10px] font-medium"
              >
                {kpi.name}: {kpi.target}
              </span>
            ))}
            {kpis.length > 2 && (
              <span className="text-[10px] text-muted-foreground">+{kpis.length - 2} more</span>
            )}
          </div>
        )}

        {/* View Details Link */}
        <div className="flex items-center justify-end mt-2 text-primary text-xs font-medium">
          <span>View Details</span>
          <ArrowRight size={12} className="ml-1" />
        </div>
      </div>
    </div>
  );
}

export default memo(RoleNode);
